export default __webpack_public_path__ + "play-circle.png";